import {
    FontAwesomeIcon,
    FontAwesomeLayers,
    FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';
import { AuthService } from '@skinsoft/auth';
import {
    AliasDataStore,
    AliasDataStore as CollaboratorDataStore,
    ExpressionDataStore,
    ItemDataStore,
    LocationDataStore,
    ManifestationDataStore,
    MovementDataStore,
    TaskDataStore,
    ThesaurusTermDataStore,
    WorkDataStore,
    WorkspaceDataStore,
} from '@skinsoft/entity';
import { TranslationDataStore } from '@skinsoft/i18n';
import { Field, Form, LocalizedDate, LocalizedString } from '@skinsoft/ui';
import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Router from 'vue-router';
import Toasted from 'vue-toasted';

import { Firewall } from '@skinsoft/auth/src/components/firewall';
import { MediaTransferHelper } from '@skinsoft/media-transfer-helper';

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);
Vue.component('s-form', Form);
Vue.component('s-field', Field);
Vue.component('s-firewall', Firewall);
Vue.component('s-localized-date', LocalizedDate);
Vue.component('s-localized-string', LocalizedString);

Vue.use(BootstrapVue);
Vue.use(Router);
Vue.use(Toasted);

Vue.use(AuthService);
Vue.use(VueI18n);

Vue.use(AliasDataStore);
Vue.use(CollaboratorDataStore);
Vue.use(ExpressionDataStore);
Vue.use(ItemDataStore);
Vue.use(LocationDataStore);
Vue.use(ManifestationDataStore);
Vue.use(MovementDataStore);
Vue.use(TaskDataStore);
Vue.use(ThesaurusTermDataStore);
Vue.use(TranslationDataStore);
Vue.use(WorkDataStore);
Vue.use(WorkspaceDataStore);
Vue.use(MediaTransferHelper)

Vue.config.devtools = true;
Vue.config.productionTip = false;
